import React, { useState } from "react";
import { useLang } from "../../context/LangContext";
import { FAQ_ITEMS, STRINGS, YOUTUBE_URL } from "../../data/content";

export default function FAQ() {
  const { t } = useLang();
  const [openIdx, setOpenIdx] = useState(-1);

  const toggle = (idx) => setOpenIdx((cur) => (cur === idx ? -1 : idx));

  return (
    <section className="section" style={{ background: "var(--off-white)" }}>
      <div className="section-inner">
        <div className="fade-in">
          <div className="section-label">{t(STRINGS.faqLabel)}</div>
        </div>
        <h2 className="section-title fade-in">{t(STRINGS.faqTitle)}</h2>
        <div className="faq-list">
          {FAQ_ITEMS.map((item, idx) => {
            const open = openIdx === idx;
            return (
              <div className="fade-in" key={item.id}>
                <div className={`faq-item${open ? " open" : ""}`}>
                  <button
                    className="faq-question"
                    onClick={() => toggle(idx)}
                    aria-expanded={open}
                  >
                    <span className="faq-q-text">{t(item.q)}</span>
                    <span className="faq-toggle">+</span>
                  </button>
                  <div className="faq-answer">
                    <p>{t(item.a)}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="yt-badge fade-in">
          <span style={{ fontSize: 22, color: "var(--red)" }}>▶</span>
          <span>
            <a href={YOUTUBE_URL} target="_blank" rel="noopener noreferrer">
              {t(STRINGS.ytBadgeLink)}
            </a>{" "}
            <span>{t(STRINGS.ytBadgeSuffix)}</span>
          </span>
        </div>
      </div>
    </section>
  );
}
